import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import grey from "@material-ui/core/colors/grey";
import blue from "@material-ui/core/colors/blue";
import Button from "@material-ui/core/Button";
import WarningOutlined from "@material-ui/icons/WarningOutlined";
import HelpOutline from "@material-ui/icons/HelpOutline";
import AccessTimeOutlined from "@material-ui/icons/AccessTimeOutlined";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import AccountBalanceWalletOutlined from "@material-ui/icons/AccountBalanceWalletOutlined";

import AppBarTransparent from "../shared/components/AppBarTransparent";
import OngoingTestDetailForm from "./components/OngoingTestDetailForm";
import { connect } from "react-redux";
import { getInvitationById } from "../../redux/actions/sagaActions";

import CircularProgress from "@material-ui/core/CircularProgress";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";

const styles = theme => ({
  card: {
    maxWidth: 240
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover",
    height: 180,
    position: "relative"
  },
  container: {
    padding: 20
  },
  textRight: {
    textAlign: "right"
  },
  helpButton: {
    width: 32,
    height: 32
  },
  flexCenter: {
    display: "flex",
    alignItems: "center"
  },
  duracion: {
    justifyContent: "flex-end",
    color: grey["600"],
    fontWeight: 500
  },
  time: {
    justifyContent: "flex-end"
  },
  iconDate: {
    fontSize: 20,
    marginRight: 5
  },
  durationOverImageContainer: {
    position: "absolute",
    right: 25,
    top: "50%",
    color: "#fff"
  },
  leftIcon: {
    marginRight: theme.spacing.unit * 0.5
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  },
  buttonDanger: {
    color: "#FFF",
    textTransform: "initial",
    paddingRight: 0
    //textShadow: '1px 1px 1px rgba(109, 109, 109, 1)'
  },
  progress: {
    colorPrimary: {
      backgroundColor: blue["600"]
    },
    barColorPrimary: {
      backgroundColor: blue["600"]
    },
    bar1Buffer: {
      backgroundColor: blue["600"],
      color: blue["600"]
    }
  }
});

class OngoingTestDetail extends React.PureComponent {
  el = null;

  state = {
    appBar: {
      background: "transparent"
    },
    activeTab: 0
  };

  componentDidMount() {
    this.el = document.getElementById("root");
    window.addEventListener("scroll", this.fireOnScroll, true);
    const {
      getInvitationById,
      match: {
        params: { id }
      }
    } = this.props;
    getInvitationById({ id });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.fireOnScroll, true);
  }

  fireOnScroll = e => {
    let offset = this.el.scrollTop;

    if (offset >= 10) {
      this.setState({
        appBar: {
          background:
            "rgba(237,74,71," + (offset <= 99 ? "0." + offset : 1) + ")"
        }
      });
    } else {
      this.setState({
        appBar: {
          background: "transparent"
        }
      });
    }
  };

  handleStartDateChange = date => {
    this.setState({ selectedStartDate: date });
  };

  handleEndDateChange = date => {
    this.setState({ selectedEndDate: date });
  };

  handleTabChange = (event, value) => {
    this.setState({
      activeTab: value
    });
  };

  handleSubmit = () => {
    this.props.history.push("/test/2314532/join");
  };

  render() {
    const {
      classes,
      tests,
      match: {
        params: { id }
      },
      getInvitationById,
      invitations
    } = this.props;
    if (invitations[id] === undefined) {
      return (
        <div style={{ marginTop: "64px" }}>
          <CircularProgress />
        </div>
      );
    }
    const project = invitations[id].project;
    return (
      <div style={{ overflowY: "auto" }} id="test-detail">
        <AppBarTransparent
          background={this.state.appBar.background}
          history={this.props.history}
        />

        <CardMedia
          component="div"
          className={classes.media}
          image="/assets/img/dummy/537447438-612x612.jpg"
          title="Contemplative Reptile"
        >
          <div className={classes.durationOverImageContainer}>
            {/*<Typography*/}
            {/*  style={{ color: "#fff", fontWeight: 300, fontSize: 20 }}*/}
            {/*>*/}
            {/*  <strong>1</strong> / 30 dias*/}
            {/*</Typography>*/}
          </div>
          <div style={{ position: "absolute", bottom: 0, right: 25 }}>
            <Button
              aria-label="Informar de un problema"
              variant="flat"
              size="small"
              className={classes.buttonDanger}
              component={Link}
              to="/test/12343214/report"
            >
              <WarningOutlined
                className={classNames(classes.leftIcon, classes.iconSmall)}
                style={{ color: "#FFCC33" }}
              />
              Informar de un problema
            </Button>
          </div>
        </CardMedia>

        <div style={{ padding: 20 }}>
          <Grid container spacing={8}>
            <Grid item xs={10}>
              <Typography variant="display1" color="textPrimary">
                <strong>Test para pieles sensibles</strong>
              </Typography>
            </Grid>

            <Grid item xs={2} className={classes.textRight}>
              {/*<IconButton className={classes.helpButton}>*/}
              {/*  <HelpOutline />*/}
              {/*</IconButton>*/}
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="caption"
                paragraph
                style={{ color: grey["500"] }}
              >
                N&deg; estudio: {id}
              </Typography>
            </Grid>

            <Grid item xs={7}>
              <Typography
                className={classes.flexCenter}
                paragraph
                component="div"
              >
                <AccessTimeOutlined className={classes.iconDate} />
                <span style={{ color: grey["500"] }}>
                  Día inicio:
                </span> &nbsp;{" "}
                <strong>
                  {Array.isArray(project.medical_visits) &&
                    project.medical_visits[0] && (
                      <span>{project.medical_visits[0].date}</span>
                    )}
                </strong>
              </Typography>
              <Typography
                className={classes.flexCenter}
                paragraph
                component="div"
              >
                <div>
                  <AccessTimeOutlined className={classes.iconDate} /> Visita
                  intermedia:
                </div>
              </Typography>
              <Typography
                className={classes.flexCenter}
                paragraph
                component="div"
              >
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell align="right">Start time</TableCell>
                      <TableCell align="right">End time</TableCell>
                      <TableCell align="right">Frequency</TableCell>
                      <TableCell align="right">Duration</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(project.medical_visits) &&
                      project.medical_visits.slice(2).map(row => (
                        <TableRow key={row.id}>
                          <TableCell component="th" scope="row">
                            {row.date}
                          </TableCell>
                          <TableCell align="right">{row.start_time}</TableCell>
                          <TableCell align="right">{row.end_time}</TableCell>
                          <TableCell align="right">{row.frequency}</TableCell>
                          <TableCell align="right">{row.duration}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Typography>
              <Typography
                className={classes.flexCenter}
                paragraph
                component="div"
              >
                <AccessTimeOutlined className={classes.iconDate} />
                <span style={{ color: grey["500"] }}>Día fin:</span> &nbsp;{" "}
                <strong>
                  {Array.isArray(project.medical_visits) &&
                    project.medical_visits[1] && (
                      <span>{project.medical_visits[1].date}</span>
                    )}
                </strong>
              </Typography>
              {/*<Typography*/}
              {/*  className={classes.flexCenter}*/}
              {/*  paragraph*/}
              {/*  component="div"*/}
              {/*>*/}
              {/*  <AccountBalanceWalletOutlined className={classes.iconDate} />*/}
              {/*  <span style={{ color: grey["500"] }}>*/}
              {/*    Retribucion:*/}
              {/*  </span> &nbsp; <strong>45 &euro;</strong>*/}
              {/*</Typography>*/}
            </Grid>
            <Grid item xs={5}>
              <LinearProgress
                variant="buffer"
                color="primary"
                value={37}
                valueBuffer={10}
                classes={{
                  bar1Buffer: classes.progress.bar1Buffer,
                  bar2Buffer: classes.progress.bar1Buffer
                }}
                style={{ marginTop: 5 }}
              />
              <Typography variant="caption" style={{ color: grey["500"] }}>
                En proceso
              </Typography>
            </Grid>
          </Grid>
        </div>

        {invitations[id] ? (
          <OngoingTestDetailForm invitation={invitations[id]} />
        ) : (
          <CircularProgress />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tests: state.tests.encurso,
  invitations: state.tests.invitations
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    { getInvitationById }
  )(OngoingTestDetail)
);



// WEBPACK FOOTER //
// ./src/modules/test/OngoingTestDetail.js